import { types as sdkTypes } from '../util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
//
// NOTE: these are highly recommended, since they
//       1) help customers to find relevant locations, and
//       2) reduce the cost of using map providers geocoding API
// const defaultLocations = [
//   {
//     id: 'default-helsinki',
//     predictionPlace: {
//       address: 'Helsinki, Finland',
//       bounds: new LatLngBounds(new LatLng(60.29783, 25.25448), new LatLng(59.92248, 24.78287)),
//     },
//   },
//   {
//     id: 'default-turku',
//     predictionPlace: {
//       address: 'Turku, Finland',
//       bounds: new LatLngBounds(new LatLng(60.53045, 22.38197), new LatLng(60.33361, 22.06644)),
//     },
//   },
//   {
//     id: 'default-tampere',
//     predictionPlace: {
//       address: 'Tampere, Finland',
//       bounds: new LatLngBounds(new LatLng(61.83657, 24.11838), new LatLng(61.42728, 23.5422)),
//     },
//   },
//   {
//     id: 'default-oulu',
//     predictionPlace: {
//       address: 'Oulu, Finland',
//       bounds: new LatLngBounds(new LatLng(65.56434, 26.77069), new LatLng(64.8443, 24.11494)),
//     },
//   },
//   {
//     id: 'default-ruka',
//     predictionPlace: {
//       address: 'Ruka, Finland',
//       bounds: new LatLngBounds(new LatLng(66.16997, 29.16773), new LatLng(66.16095, 29.13572)),
//     },
//   },
// ];
const defaultLocations = [
  {
    id: 'default-london',
    predictionPlace: {
      address: 'London, United Kingdom',
      bounds: new LatLngBounds(new LatLng(51.669993, 0.153177),new LatLng(51.384527, -0.351708)),
    },
  },
  {
    id: 'default-manchester',
    predictionPlace: {
      address: 'Manchester, United Kingdom',
      bounds: new LatLngBounds(new LatLng(53.586199, -2.087832), new LatLng(53.348598, -2.52355)),
    },
  },
  {
    id: 'default-birmingham',
    predictionPlace: {
      address: 'Birmingham, United Kingdom',
      bounds: new LatLngBounds(new LatLng(52.570615, -1.597742), new LatLng(52.327674, -2.045202)),
    },
  },
  {
    id: 'default-edinburgh',
    predictionPlace: {
      address: 'Edinburgh, United Kingdom',
      bounds: new LatLngBounds(new LatLng(56.010331, -3.073707), new LatLng(55.868615, -3.3796)),
    },
  },
  {
    id: 'default-glasgow',
    predictionPlace: {
      address: 'Glasgow, United Kingdom',
      bounds: new LatLngBounds(new LatLng(56.219682, -3.873909), new LatLng(55.675803, -4.695768)),
    },
  },
];
export default defaultLocations;
